import api from "./api";

// v217: direkte-til-R2-opplasting for veggposter. Returnerer upload_id.
export async function uploadPostFile(file, purpose = "post", onProgress) {
  const { data } = await api.post("/profile-posts/uploads/init", {
    filename: file.name,
    content_type: file.type,
    size: file.size,
    purpose,
  });
  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", data.upload_url, true);
    xhr.setRequestHeader("Content-Type", file.type);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300
      ? resolve()
      : reject(new Error(`Opplasting feilet (${xhr.status}). Prøv igjen.`)));
    xhr.onerror = () => reject(new Error("Nettverksfeil under opplasting. Prøv igjen."));
    xhr.send(file);
  });
  return data.upload_id;
}

export const postUploadLimit = (user) =>
  (user?.is_creator || user?.seller_verified || ["creator", "owner", "admin"].includes(user?.role))
    ? 5 * 1024 * 1024 * 1024
    : 200 * 1024 * 1024;
